import { render } from "./calificacion.vue?vue&type=template&id=8ff4ae82"
import script from "./calificacion.vue?vue&type=script&lang=js"
export * from "./calificacion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__